import { useState, useEffect, useRef } from "react";
import { Box, Typography, Link } from "@mui/material";
import ReactPlayer from "react-player";

function detectSource(url = "") {
  if (!url) return;
  if (/drive\.google\.com/.test(url)) return "DRIVE";
  if (/youtube\.com|youtu\.be/.test(url)) return "YOUTUBE";
  if (/vimeo\.com/.test(url)) return "VIMEO";
  if (/soundcloud\.com/.test(url)) return "SOUNDCLOUD";
  if (/twitter\.com|x\.com/.test(url)) return "TWITTER";
  if (/facebook\.com/.test(url)) return "FACEBOOK";
  if (/instagram\.com\/(reel|p|tv)/.test(url)) return "INSTAGRAM";
  if (/flickr\.com/.test(url)) return "FLICKR";
  return "UNKNOWN";
}

export default function VideoPreview({ watchLink, donotshowfallback = false,  onError, autoPlay = false}) {
  const [hasError, setHasError] = useState(false);
  const embedRef = useRef(null);


  const type = detectSource(watchLink);

  // ✅ Instagram embed logic inline
  useEffect(() => {
    if (type !== "INSTAGRAM") return;

    if (!window.instgrm) {
      const script = document.createElement("script");
      script.src = "https://www.instagram.com/embed.js";
      script.async = true;
      script.onload = () => window.instgrm?.Embeds?.process();
      document.body.appendChild(script);
    } else {
      window.instgrm.Embeds.process();
    }
  }, [type, watchLink]);

  if (!watchLink) return null;

    const handleError = () => {
    setHasError(true);
    onError?.();      // 👈 notify parent
  };


  return (
    <>
      {hasError && !donotshowfallback ? (
        <Box
          sx={{
            p: 2,
            textAlign: "center",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 2,
          }}
        >
          <Typography variant="body2" gutterBottom color="textSecondary">
            Video preview not available for this link.
          </Typography>
          <Link href={watchLink} target="_blank" rel="noreferrer" underline="hover" variant="body2">
            View on external site
          </Link>
        </Box>
      ) : (
        !hasError && (

          <Box
            sx={{
              width: "100%",
              aspectRatio: "16/9",
              overflow: "hidden",
              borderRadius: 2,
            }}
          >
            {type === "DRIVE" || type === "FACEBOOK" ? (
              <iframe
                src={watchLink}
                title="Video Player"
                allow="autoplay; fullscreen"
                width="100%"
                height="100%"
                style={{ border: "none" }}
                 onError={handleError}
              />
            ) : type === "INSTAGRAM" ? (
              <blockquote
                ref={embedRef}
                className="instagram-media"
                data-instgrm-permalink={watchLink}
                data-instgrm-version="14"
                style={{
                  width: "100%",
                  margin: "0 auto",
                }}
              />
            ) : (
              <ReactPlayer
                src={watchLink}
                controls
                playing={autoPlay}
                width="100%"
                height="100%"
                playsinline
                  onError={handleError}
                config={{
                  file: {
                    attributes: {
                      controlsList: "nodownload",
                    },
                  },
                }}
              />
            )}
          </Box>

        )
      )}
    </>
  );
}
